/* Family "All": one card per product, only variant-backed images. */
(function () {
  'use strict';
  function slug(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function familyColors(doc, location) {
    var families = doc.querySelectorAll('.color_family_main .color_family_all');
    for (var i = 0; i < families.length; i++) {
      var links = Array.from(families[i].querySelectorAll('.content_color_all .color_box_new_image a[href]'));
      var all = links.find(function (link) {
        var label = link.querySelector('.color_text');
        if (!label || slug(label.textContent) !== 'all') return false;
        var url = new URL(link.getAttribute('href'), location.href);
        if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return false;
        // Some menus use a shared collection path with a color constraint.
        return url.searchParams.get('constraint') === new URL(location.href).searchParams.get('constraint') ||
          !url.searchParams.has('constraint');
      });
      if (all) {
        return Array.from(new Set(links.map(function (link) {
          var label = link.querySelector('.color_text');
          return label ? slug(label.textContent) : '';
        }).filter(function (color) { return color && color !== 'all'; })));
      }
    }
    return [];
  }
  function choose(colors, variants, position) {
    if (!colors.length) return null;
    // Rotate only through shades this product can actually display.
    var eligible = colors.map(function (color) {
      return variants.find(function (item) {
        return item.color === color && /^\d+$/.test(item.id) && item.image;
      });
    }).filter(Boolean);
    if (!eligible.length) return null;
    var start = Math.max(0, (Number(position) || 1) - 1) % eligible.length;
    return eligible[start];
  }
  function variantHref(href, id, base) {
    var url = new URL(href, base);
    url.searchParams.set('variant', id);
    return url.pathname + url.search + url.hash;
  }
  function imageWidth(src, width, base) {
    var url = new URL(src, base);
    url.searchParams.set('width', width);
    return url.href;
  }
  function apply(product, colors, location) {
    if (!colors.length) return false;
    // Suppress the legacy filename/metafield fallback on a family-All page.
    if (product.getAttribute('data-cs-family-resolved')) return true;
    var variants;
    try { variants = JSON.parse(product.getAttribute('data-cs-family-variants') || '[]'); }
    catch (_) { return true; }
    if (!Array.isArray(variants)) return true;
    var selected = choose(colors, variants, product.getAttribute('data-cs-family-position'));
    var image = product.querySelector('.images-one') || product.querySelector('img');
    if (!selected || !image) return true;
    var src = imageWidth(selected.image, 720, location.href);
    var srcset = [180, 360, 540, 720].map(function (width) {
      return imageWidth(selected.image, width, location.href) + ' ' + width + 'w';
    }).join(', ');
    var images = [image, product.querySelector('.images-two img')].filter(Boolean);
    images.forEach(function (img) {
      img.setAttribute('data-src', src);
      img.setAttribute('data-srcset', srcset);
      img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
    });
    product.setAttribute('href', variantHref(product.getAttribute('href'), selected.id, location.href));
    var card = product.closest('.product-item');
    if (card) {
      card.querySelectorAll('.product-title[href], .product-bottom a[href]').forEach(function (link) {
        if (new URL(link.getAttribute('href'), location.href).pathname.indexOf('/products/') !== -1) {
          link.setAttribute('href', variantHref(link.getAttribute('href'), selected.id, location.href));
        }
      });
    }
    product.setAttribute('data-cs-family-resolved', selected.color + ':' + selected.id);
    return true;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { familyColors: familyColors, choose: choose, apply: apply, variantHref: variantHref };
  }
  if (typeof window === 'undefined') return;
  var colors;
  window.csApplyFamilyAllImage = function (product) {
    if (!document.body.classList.contains('template-collection')) return false;
    if (!colors || !colors.length) colors = familyColors(document, window.location);
    return apply(product, colors, window.location);
  };
})();
